<template>
  <transition name="fade">
    <div
      class="page-component-up"
      @click="backToTop"
      v-show="visible"
      :style="customStyle"
    >
      <!-- <i class="el-icon-arrow-up"></i> -->
      <ul class>
        <li>
          <i class="el-icon-arrow-up" style="font-size: 30px"></i>
          <span style="display: inline-block; margin-top: 5px">回到顶部</span>
        </li>
        <!-- <li @click="toUrl('/work/work-list?type=tousu')">投诉</li> -->
      </ul>
    </div>
  </transition>
</template>

<script>
export default {
  name: "BackToTop",
  props: {},
  data() {
    return {
      visible: false,
      interval: null,
      visibilityHeight: 800,
      backPosition: 0,
      customStyle: {
        width: "70px",
        height: "70px",
        background: "#fff",
      },
    };
  },
  mounted() {
    window.addEventListener("scroll", this.handleScroll);
  },
  beforeDestroy() {
    window.removeEventListener("scroll", this.handleScroll);
    if (this.interval) {
      clearInterval(this.interval);
    }
  },
  methods: {
    handleScroll() {
      this.visible = window.pageYOffset > this.visibilityHeight;
    },
    backToTop() {
      let distanceY = window.pageYOffset;
      let i = 0;
      this.interval = setInterval(() => {
        let next = Math.floor(
          this.easeInOutQuad(10 * i, distanceY, -distanceY, 500)
        );
        if (next <= this.backPosition) {
          window.scrollTo(0, this.backPosition);
          clearInterval(this.interval);
        } else {
          window.scrollTo(0, next);
        }
        i++;
      }, 17);
    },
    /*
      缓动公式（Tween算法）
       t: 动画已经执行的时间（实际上时执行多少次/帧数）
       b: 起始位置
       c: 终止位置
       d: 从起始位置到终止位置的经过时间（实际上时执行多少次/帧数）
    */
    easeInOutQuad(t, b, c, d) {
      // 判断当前时间是否总在总时间的一半以内，是的话执行缓入函数，否则的话执行缓出函数
      if ((t /= d / 2) < 1) {
        return (c / 2) * t * t + b;
      } else {
        // 将总长度设置为一半，并且时间从当前开始递减，对图像进行垂直向上平移
        return (-c / 2) * (--t * (t - 2) - 1) + b;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.page-component-up {
  position: fixed;
  right: 10%;
  bottom: 19%;
  cursor: pointer;
  text-align: center;
  transition: 0.3s;
  // box-shadow: 0 0 6px rgba(0, 0, 0, 0.12);
  z-index: 1024;
  ul {
    height: 150px;
    margin: 0 auto;
    li {
      list-style: none;
      height: 70px;
      width: 70px;
      background: #fff;
      border-bottom: 1px solid #dce4e6;
      padding-top: 10px;
      text-align: center;
      font-size: 12px;
      // color: #fff;
      position: relative;
      cursor: pointer;
    }
    li:hover {
      background: #ee424e;
      color: #fff;
    }
  }
}

// @media screen and (min-width: 1680px) {
//   .page-component-up {
//     right: 20px;
//   }
// }

// @media screen and (min-width: 1025px) and (max-width: 1679px) {
//   .page-component-up {
//     right: 10px;
//   }
// }

// @media screen and (max-width: 1024px) {
//   .page-component-up {
//     right: 0;
//   }
// }
</style>



// WEBPACK FOOTER //
// src/components/master/to-top.vue